import React, { useEffect, useState } from 'react';
import type { LocalizationProviderProps } from '@mui/x-date-pickers/LocalizationProvider';
import type { Locale } from 'date-fns';

type AdapterCtor = NonNullable<LocalizationProviderProps<Locale>['dateAdapter']>;
type LocalizationProviderComponent = React.ComponentType<LocalizationProviderProps<Locale>>;

export function DateProviders({ children }: { children: React.ReactNode }) {
	const [LocalizationProvider, setLocalizationProvider] = useState<LocalizationProviderComponent | null>(null);
	const [AdapterCtorRef, setAdapterCtorRef] = useState<AdapterCtor | null>(null);
	const [locale, setLocale] = useState<Locale | undefined>(undefined);

	useEffect(() => {
		let cancelled = false;

		async function load() {
			const [{ LocalizationProvider }, { AdapterDateFns }, { enIE }] = await Promise.all([
				import('@mui/x-date-pickers/LocalizationProvider'),
				import('@mui/x-date-pickers/AdapterDateFns'),
				import('date-fns/locale/en-IE')
			]);

			if (!cancelled) {
				setLocalizationProvider(() => LocalizationProvider);
				setAdapterCtorRef(() => AdapterDateFns as unknown as AdapterCtor);
				setLocale(enIE);
			}
		}

		load();
		return () => {
			cancelled = true;
		};
	}, []);

	if (!LocalizationProvider || !AdapterCtorRef) {
		return null;
	}

	return (
		<LocalizationProvider
			dateAdapter={AdapterCtorRef}
			adapterLocale={locale}
		>
			{children}
		</LocalizationProvider>
	);
}

export default DateProviders;
